module.exports = ['IDEAFactory', 'PoolCoordinator', 'VOTEToken']
